import { SelectController } from '@organisms';
import { Col, Flex, Row } from 'antd';
import { FC } from 'react';
import { Control } from 'react-hook-form';

import { OfferFormData } from '../../../interfaces/offersInterface';

interface FormMobileProps {
  control: Control<OfferFormData>;
  isDisabled: boolean;
  itunesOptions: Array<{ label: string; value: string }>;
  googleOptions: Array<{ label: string; value: string }>;
}

export const FormMobile: FC<FormMobileProps> = ({
  control,
  itunesOptions,
  googleOptions,
  isDisabled,
}) => {
  return (
    <Flex vertical>
      <Row style={{ gap: '24px' }}>
        <Col style={{ flex: 1 }}>
          <SelectController
            control={control}
            name='mobile.itunesStoreId'
            placeholder='Selecione o ID da Apple Store'
            label='ID Loja Apple'
            options={itunesOptions}
            disabled={isDisabled}
          />
        </Col>
        <Col style={{ flex: 1 }}>
          <SelectController
            control={control}
            name='mobile.googleStoreId'
            placeholder='Selecione o ID da Google Play'
            label='ID Loja Google'
            options={googleOptions}
            disabled={isDisabled}
          />
        </Col>
      </Row>
    </Flex>
  );
};
